import { connect } from "react-redux";
import MobileLayout from "../MobileLayout";

export const mapStateToProps = state => {
  return {
    selectedTab: state.selectedTab
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

// Container Component
const MobileLayoutContainer = connect(mapStateToProps, mapDispatchToProps)(
  MobileLayout
);

export default MobileLayoutContainer;



// WEBPACK FOOTER //
// ./src/containers/MobileLayoutContainer.js